interface MostUsedAutomationProps {
  title: string;
}

export const MostUsedAutomation = ({ title }: MostUsedAutomationProps) => (
  <div className="relative w-full max-w-md">
    <div className="absolute inset-0 translate-y-4 rounded-2xl bg-white/15" />
    <div className="absolute inset-0 translate-y-8 rounded-xl bg-white/[0.04]" />

    <div className="relative z-10 inline-flex h-48 flex-col items-start justify-center gap-12 rounded-xl border border-[rgba(228,231,235,0.12)] bg-[#314A52] p-5 w-full">
      <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-[#0FBD41] p-4">
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.8913 1.83244C10.8913 0.878403 9.66035 0.49511 9.11871 1.28048L2.47043 10.9205C2.02563 11.5654 2.48731 12.4447 3.27077 12.4447H7.78017V16.8347C7.78017 17.7887 9.0111 18.172 9.55274 17.3867L16.201 7.74664C16.6458 7.10169 16.1841 6.22246 15.4007 6.22246H10.8913V1.83244Z"
            fill="white"
          />
        </svg>
      </div>
      <h3 className="text-white text-base font-semibold leading-tight text-balance line-clamp-3">
        {title}
      </h3>
    </div>
  </div>
);
